export default __webpack_public_path__ + "static/media/preprint_Ou_et_al_2024_biorxiv.9ca323fc.pdf";